"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fit = void 0;
exports.fit = {
    path: "M3 5.5H5.5V3H7.16667V7.16667H3V5.5ZM5.5 13.8333H3V12.1666H7.16667V16.3333H5.5V13.8333ZM12.1667 16.3333H13.8334V13.8333H16.3334V12.1666H12.1667V16.3333ZM13.8334 3V5.5H16.3334V7.16667H12.1667V3H13.8334Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
